import { IonRow, IonCol, IonText, IonIcon } from "@ionic/react";
import { basketOutline } from "ionicons/icons";
import React from "react";

import styles from "./MainPageProduct.module.scss";
import classNames from "classnames/bind";
import { Product, ProductType } from "@core/types";
import { useCartData } from "../../../../../providers/cartDataStore";
import { useCreatePriceMarkup } from "../../../../../utils/useCreatePriceMarkup";
import { useProductCardActions } from "../../../../../providers/useProductActions";
import { useTranslation } from "react-i18next";

interface BasketIconProps {
  product: Product;
}

const cx = classNames.bind(styles);

const BasketIcon = ({ product }: BasketIconProps) => {
  const { cartProductsMap } = useCartData();
  const { addToCart, showProductDetail } = useProductCardActions();
  const { t } = useTranslation();

  const cartQuantity = cartProductsMap[product.id]?.quantity ?? 0;
  const priceHtml = useCreatePriceMarkup(product);

  return (
    <IonRow
      className={cx(
        "!bg-transparent flex justify-between w-full items-center md:h-[2.1rem]",
        product.stockStatus !== "instock" && "flex-col"
      )}
    >
      <IonCol
        size={product.stockStatus === "instock" ? "7" : "12"}
        className={cx(
          "ion-no-padding ion-text-start hidden md:block",
          product.stockStatus === "instock" && "ion-text-start"
        )}
      >
        {(product.stockQuantity > 0 || product.type === ProductType.VARIABLE) && (
          <p
            className={cx("price ellipsis", styles.price, styles.price__general, "main-page-price-amount")}
            dangerouslySetInnerHTML={priceHtml}
          ></p>
        )}
      </IonCol>
      {product.stockQuantity > 0 ? (
        <IonCol
          size="12"
          sizeMd={product.stockStatus === "instock" ? "3.5" : "12"}
          className={cx(
            "ion-text-center ion-no-padding",
            product.stockStatus !== "instock" && "ion-text-start",
            "active:transition active:duration-200 active:scale-110",
            {
              disabled: product.stockQuantity < 1 || !product?.purchasable || cartQuantity === product.stockQuantity,
            }
          )}
          onClick={(e) => {
            e.stopPropagation();
            addToCart(product);
          }}
        >
          {product.stockStatus === "instock" ? (
            <>
              <IonText className="text-xs rounded-xl font-bold py-[10px] text-primary-contrast bg-primary block md:hidden">
                {t("Add to cart")}
              </IonText>
              <IonIcon icon={basketOutline} className={cx(styles.icon, "hidden text-lg md:block")} />
            </>
          ) : (
            <IonText className={cx("out-of-stock")}>{t("Out of Stock")}</IonText>
          )}
        </IonCol>
      ) : (
        <IonCol
          size="12"
          sizeMd="3"
          className={cx("ion-text-center ion-no-padding")}
          onClick={(e) => {
            showProductDetail(product.id);
            e.stopPropagation();
          }}
        >
          {product.stockStatus === "instock" && (
            <>
              <IonText className="rounded-xl font-bold py-[10px] text-xs text-primary-contrast bg-primary block md:hidden">
                {t("Add to cart")}
              </IonText>
              <IonIcon icon={basketOutline} className={cx(styles.icon, "hidden md:block")} />
            </>
          )}
        </IonCol>
      )}
    </IonRow>
  );
};

export default BasketIcon;
